import React, { FC } from 'react';
import { Alert, Button } from '@mui/material';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { logout } from 'utils/logout';
import { useTranslation } from 'react-i18next';

/**
 * DD-3613: shown while a super admin uses this app as a user, opened from the
 * super admin UI. There is nothing to switch back to here; the super admin's
 * own session lives in that UI.
 */
const SuperAdminBar: FC = () => {
    const currentUser = useReactiveVar(currentUserVar);
    const { t: translate } = useTranslation('common');

    if (!currentUser?.impersonatedByEmail) return null;

    return (
        <Alert
            severity="info"
            sx={{ mb: 2 }}
            action={
                <Button color="inherit" size="small" onClick={() => logout(false)}>
                    {translate('END_IMPERSONATION_SESSION')}
                </Button>
            }
        >
            {translate('IMPERSONATED_BY_SUPER_ADMIN', { email: currentUser.impersonatedByEmail })}
        </Alert>
    );
};

export default SuperAdminBar;
